import { render } from "./AssessmentsTable.vue?vue&type=template&id=62a2fc33"
import script from "./AssessmentsTable.vue?vue&type=script&lang=js"
export * from "./AssessmentsTable.vue?vue&type=script&lang=js"

import "./AssessmentsTable.vue?vue&type=style&index=0&id=62a2fc33&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__